import { useEffect, useCallback } from 'react';
import socketService from '../services/socket';

export const useSocket = (token, userId, userType, organizationId) => {
  useEffect(() => {
    if (token && userId && userType && organizationId) {
      socketService.connect(token, userId, userType, organizationId);
    }

    return () => {
      socketService.disconnect();
    };
  }, [token, userId, userType, organizationId]);

  const sendMessage = useCallback((conversationId, content, recipientId) => {
    socketService.sendMessage(conversationId, content, recipientId);
  }, []);

  const sendTyping = useCallback((conversationId, isTyping) => {
    socketService.sendTyping(conversationId, isTyping);
  }, []);

  const markAsRead = useCallback((conversationId) => {
    socketService.markAsRead(conversationId);
  }, []);

  return {
    sendMessage,
    sendTyping,
    markAsRead,
    isConnected: socketService.isConnected(),
    onNewMessage: socketService.onNewMessage.bind(socketService),
    onUserTyping: socketService.onUserTyping.bind(socketService),
    onMessagesRead: socketService.onMessagesRead.bind(socketService),
    onUserPresence: socketService.onUserPresence.bind(socketService),
    off: socketService.off.bind(socketService)
  };
};
